import script from "./alert-trend-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./alert-trend-card.vue?vue&type=script&lang=ts&setup=true"

import "./alert-trend-card.vue?vue&type=style&index=0&id=3e01efe6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e01efe6"]])

export default __exports__